/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
  NotificationsDispatchPublicControllerEmailAutoLoginQueryParams,
} from '../types/NotificationsDispatchPublicControllerEmailAutoLogin.ts';

function getNotificationsDispatchPublicEmailAutoLoginUrl() {
  const res = { method: 'GET', url: `/api/telegram/notifications/email-auto-login` as const };
  return res;
}

/**
 * {@link /api/telegram/notifications/email-auto-login}
 */
export async function notificationsDispatchPublicEmailAutoLogin(
  params: NotificationsDispatchPublicControllerEmailAutoLoginQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getNotificationsDispatchPublicEmailAutoLoginUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
